import { useLogout as usePrivyLogout } from '@privy-io/react-auth';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearExternalWalletBalances } from '../redux/slices/walletSlice';
import { useSolana } from './useSolana';
import { setPrivyToken } from '../redux/slices/auth';
import { authorizedApi } from '../redux/api/authorized';
import { resetWalletBalances } from '../redux/slices/walletSlice';
import { reinitializeVerisoul } from '../common/verisoul';
import { clearValidationResult } from '../redux/slices/sessionValidation';

export const useLogout = (setIsOpen = null) => {
  const { logout } = usePrivyLogout();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { externalWallet } = useSolana();

  const handleDisconnectWallet = async () => {
    if (externalWallet && externalWallet?.disconnect) {
      await externalWallet.disconnect();
      dispatch(clearExternalWalletBalances());
    }
  };

  const handleLogout = async () => {
    // Reinitialize Verisoul session before logout
    // Do it async to avoid blocking the logout process

    reinitializeVerisoul();

    // Logout from Privy
    await logout();

    dispatch(setPrivyToken(null));
    dispatch(authorizedApi.util.resetApiState());

    dispatch(resetWalletBalances());
    dispatch(clearValidationResult());
    handleDisconnectWallet();

    // Close dropdown if provided
    if (setIsOpen) {
      setIsOpen(false);
    }

    // Navigate to home page
    navigate('/');
  };

  return { handleLogout, handleDisconnectWallet };
};
